import script from "./ContentWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./ContentWrapper.vue?vue&type=style&index=0&id=d98b2744&scoped=true&lang=scss"
import "./ContentWrapper.vue?vue&type=style&index=1&id=d98b2744&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d98b2744"]])

export default __exports__